import AWS from "aws-sdk";
import { fileBaseUrl } from "..";
import { AWS_REGION, IdentityPoolId, S3_BUCKET } from "../config";
const REGION = AWS_REGION;

AWS.config.region = REGION;
AWS.config.update({
  region: REGION,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: IdentityPoolId,
  }),
});

const myBucket = new AWS.S3({
  params: { Bucket: S3_BUCKET },
  region: REGION,
});

export const s3upload = (file, onProgress, path = "") => {
  return file ? new Promise(function (resolve, reject) {
    var fileNameArr = file?.name?.split(".");
    var fileName = Date.now() + "_." + fileNameArr[fileNameArr?.length - 1];
    var filePath = path + fileName;
    // var fileUrl = 'https://' + REGION + '.amazonaws.com/'+S3_BUCKET+"/"+ filePath;
    var fileUrl = fileBaseUrl + filePath;
    myBucket
      .upload(
        {
          Key: filePath,
          Body: file,
        },
        function (err, data) {
          if (err) {
            console.log(err, " ", data);
            reject("error");
          }
        }
      )
      .on("httpUploadProgress", function (progress) {
        onProgress(progress);
        if (progress?.loaded === progress?.total) {
          resolve({
            domain: fileBaseUrl,
            filePath,
            fileName: fileUrl.split("/").pop(),
            uri: fileUrl,
          });
        }
      });
  }) : {}
};

export const s3Delete = (filePath) => {
  return new Promise(function (resolve, reject) {
    myBucket.deleteObject(
      {
        Key: filePath,
      },
      function (err, data) {
        if (err) {
          console.error(err, " ", data);
          reject(err);
        } else {
          resolve(data);
        }
      }
    );
  });
};
